<template>
    <el-container>
      <el-aside :width="isCollapse?'64px':'200px'" style="transition: all 0.6s;">
        <div class="title">
          <div>
<!--            <span v-if="isOnly">Only</span>-->
<!--            <span v-else>一伴</span>-->
            <span>{{ isOnly?'Only':isLinlu?'林鹿':'一伴' }}</span>
            <span v-if="!isCollapse">管理系统</span></div>
          <div class="tip" v-if="!isCollapse">Management System</div>
        </div>
        <SideBar />
      </el-aside>
      <el-container>
        <el-header height="48px">
          <div class="flex-style">
            <CollapseBtn :state="isCollapse" @click="toggleSideBar"/>
            <Search />
            <TagsView/>
          </div>
          <div class="flex-style">
            <UserInfo />
          </div>
        </el-header>
        <el-main class="main-container">
          <BackToTop target=".main-container"/>
          <AppMain />
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import SideBar from './components/SideBar'
import Search from './components/Search'
import AppMain from './components/AppMain'
import CollapseBtn from "./components/CollapseBtn";
import UserInfo from "./components/UserInfo"
import TagsView from "./components/TagsView"
import BackToTop from "./components/BackToTop"

export default {
  name: "Layout",
  components: { SideBar, Search, AppMain, CollapseBtn, UserInfo, TagsView, BackToTop },
  data() {
    return {
      isOnly: false,
      isLinlu: false,
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.sidebar.opened
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
  },
  mounted() {
    if(window.location.hostname == 'only.backstage.yiban1314.com' ) {
      this.isOnly = true
    }
    if(window.location.hostname == 'backstage.youban1314.cn'  || window.location.port == '20030' ) {
      this.isLinlu = true
    }
  }
}
</script>
<style lang="scss" scoped>
.main-container {
  height: calc(100vh - 48px);
  overflow-x: hidden;
}
.title {
  font-family: "微软雅黑", Arial, sans-serif;
  margin: 24px 16px 16px;
  color: #eee;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 1px;
}
.tip {
  font-size: 12px;
  font-weight: normal;
  color: rgba(255,255,255,0.3);
}
.flex-style {
  display: flex;
  align-items: center;
}

</style>
